// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2255389d3b6d76a20891be638c11b6b366cd0a79.chunk.bundle.js";
};